import './file-icon-preview.scss';

import { CloseCircleFilled } from '@/media/antd-icons';
import ErrorDocumentIcon from '@/media/icons/error-document.svg?react';
import ImageDocumentIcon from '@/media/icons/image-document.svg?react';
import PdfDocumentIcon from '@/media/icons/pdf-document.svg?react';
import UnknownDocumentIcon from '@/media/icons/unknown-document.svg?react';

type TProps = {
  fileName: string;
  isImage: boolean;
  extension: string;
  showError?: boolean;
  minified?: boolean;
  halfOpacity?: boolean;
};

const FileIconPreview = ({
  extension,
  showError = false,
  fileName,
  isImage,
  minified = false,
  halfOpacity = false
}: TProps) => {
  const getDocumentIcon = () => {
    if (showError) {
      return <ErrorDocumentIcon className="file-icon-preview__document-icon" />;
    }
    if (isImage) {
      return <ImageDocumentIcon className="file-icon-preview__document-icon" />;
    }
    switch (extension) {
      case 'pdf':
        return <PdfDocumentIcon className="file-icon-preview__document-icon" />;
      default:
        return (
          <UnknownDocumentIcon className="file-icon-preview__document-icon" />
        );
    }
  };

  return (
    <div
      className={`file-icon-preview ${minified ? 'file-icon-preview--minified' : ''}`}
    >
      <div
        className={`file-icon-preview__relative-container ${halfOpacity ? 'file-icon-preview__relative-container--half-opacity' : ''}`}
      >
        {getDocumentIcon()}
        {showError && (
          <CloseCircleFilled className="file-icon-preview__error-icon" />
        )}
      </div>
      {!!fileName && (
        <span className="file-icon-preview__document-name">{fileName}</span>
      )}
    </div>
  );
};

export default FileIconPreview;
